import request from '@/utils/request'
import { tokenName } from '@/config'

export async function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
  })
}
export async function v2login(data) {
  return request({
    url: '/v2/login',
    method: 'post',
    data,
  })
}
// 发送短信登录验证码
export async function captcha(data) {
  return request({
    url: '/login/captcha',
    method: 'post',
    data,
  })
}
export async function refresh(data) {
  return request({
    url: '/token/refresh',
    method: 'post',
    data,
  })
}

export async function getConfig(data) {
  return request({
    url: '/config/get',
    method: 'post',
    data,
  })
}

export async function socialLogin(data) {
  return request({
    url: '/socialLogin',
    method: 'post',
    data,
  })
}

export function getUserInfo(accessToken) {
  //此处为了兼容mock.js使用data传递accessToken，如果使用mock可以走headers
  return request({
    url: '/userInfo',
    method: 'post',
    data: {
      [tokenName]: accessToken,
    },
  })
}
export function getUserInfoNew() {
  return request({
    url: '/user/info',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function register() {
  return request({
    url: '/register',
    method: 'post',
  })
}


